module.exports = __webpack_public_path__ + "img/linkedin_flatline.0d3a0517.svg";